export default __webpack_public_path__ + "static/snap-partner-e595e1788f905b74a22a564b6a0c5d3b.png";